import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-manufacturer',
  templateUrl: './manufacturer.component.html',
  styleUrls: ['./manufacturer.component.less']
})
export class ManufacturerComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() mode: string;
  @Output() submitChanges: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  submit() {
    this.submitChanges.emit();
  }

  recordLoaded(record: any) {}

  beforeSubmit() {}

  cleanRecord(record: any) : any{
    return record;
  }

  static controls(mode: string) {
    const controlsToReturn: any = {};
    if(mode === 'edit') {
      controlsToReturn['Id'] = [null, []];
    }

    controlsToReturn['Name'] = [null, [Validators.required]];

    return controlsToReturn;
  }
}
